var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.list.length > 0
    ? _c(
        "div",
        {
          staticClass: "prossimi-tour px-3 py-md-2",
          attrs: { id: "partiOra" }
        },
        [
          _c("div", { staticClass: "pb-2 mb-5" }, [
            _c("h2", [_vm._v(_vm._s(_vm.title))]),
            _vm._v(" "),
            _vm.resultMessage
              ? _c("div", { staticClass: "pb-3" }, [
                  _c("span", { staticClass: "text-primary" }, [
                    _vm._v(_vm._s(_vm.resultMessage))
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("h5", { staticClass: "text-primary text-uppercase mb-0" }, [
              _vm._v(_vm._s(_vm.subtitle))
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mt-2" },
            [
              _c(
                "carousel",
                {
                  attrs: {
                    "per-page": 1,
                    "navigation-enabled": "",
                    "pagination-enabled": false,
                    "navigation-next-label": "<div></div>",
                    "navigation-prev-label": "<div></div>"
                  }
                },
                _vm._l(_vm.list, function(item, index) {
                  return _c(
                    "slide",
                    { key: index },
                    [
                      _c("VerticalItemTourMobile", {
                        attrs: { value: item },
                        on: { select: _vm.onOpenDetail }
                      })
                    ],
                    1
                  )
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.tourSelected
            ? _c("ModalTourDetail", {
                ref: "modalTourDetail",
                attrs: {
                  "is-home-page": true,
                  value: _vm.tourSelected,
                  "is-camere-requested": true
                },
                on: { select: _vm.onSelect }
              })
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2ac745b2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ac745b2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/mobile/widgets/pages/home/ProssimiTour.vue
// module id = null
// module chunks = 